import { useSelector } from "react-redux";
import PlayPreviewButton from "../../../../components/PlayPreviewButton";
import { useAudioPlayerContext } from "../../../../contexts/AudioPlayerContext";

const ChooseVoiceInline = ({
  selectedVoice = "ethan",
  onVoiceSelected,
  isChooseReceptionistOpen,
  setIsChooseReceptionistOpen,
}) => {
  const audioPlayerContext = useAudioPlayerContext();
  const voices = useSelector((state) => state.info.voices);

  const onReceptionistClicked = (voice) => {
    if (selectedVoice === voice) return;
    audioPlayerContext.stopAudio();

    const voiceObject = voices.find((v) => v.id === voice);
    onVoiceSelected(voiceObject);
    setIsChooseReceptionistOpen(false);
  };

  return (
    <div
      className={`grid w-full p-2 grid-cols-3 gap-4 md:grid-cols-6 justify-between bg-slate-100 transition-all duration-500 ease-in-out overflow-hidden space-x-2 ${
        isChooseReceptionistOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
      }`}
    >
      {voices.map((voice) => (
        <VoiceCard
          key={voice.id}
          voice={voice}
          selectedVoice={selectedVoice}
          onReceptionistClicked={onReceptionistClicked}
        />
      ))}
    </div>
  );
};

const VoiceCard = ({ voice, selectedVoice, onReceptionistClicked }) => {
  const agentLanguage = useSelector((state) => state.info.agentLanguage);

  return (
    <div
      className={`relative flex p-1 flex-1 flex-col cursor-pointer justify-between items-center rounded-md space-y-2 ${
        selectedVoice === voice.id ? "bg-slate-300" : "md:hover:bg-slate-200"
      }`}
    >
      <div
        onClick={() => onReceptionistClicked(voice.id)}
        className="flex flex-col items-center rounded-md"
      >
        <span className="text-xs md:text-sm font-semibold">{voice.name}</span>
        <img src={voice.image} alt="" className="h-14 md:h-32 object-cover rounded-md" />
      </div>
      <div className={`absolute -bottom-2 rounded-full p-0.5 bg-slate-100`}>
        <PlayPreviewButton
          voice={voice?.id}
          textToPlay={voice?.introductionSentence}
          id={`receptionist-preview-button-${voice?.id}`}
          iconSize="size-6 md:size-8"
          disabled={voice?.enablePreview === false}
          showText={false}
          language={voice.language || agentLanguage}
        />
      </div>
    </div>
  );
};

export default ChooseVoiceInline;
